import React from 'react'
import { SuccessPage } from './SuccessEnpalPages/SuccessPage'

export const SuccessSesEnpalPage = () => {
  return <SuccessPage isSes={true} />
}
